import React from 'react';
import '../Styles/AboutUs.css';
import AboutBanner from "../Assets//About/aboutbanner.png";
import AboutBannerMobile from "../Assets//About/aboutBannerMobile.png";


function AboutUs() {
    return (
        <div>
            <div className='bannerMainAbout'>
                <img src={AboutBanner} className="about_main_banner desktop" alt='mahindra blues about banner' />
                <img src={AboutBannerMobile} className="about_main_banner mobile" alt='mahindra blues about banner' />
            </div>
            <section className='aboutPage'>
                <h3 data-aos="fade-up"
                    data-aos-duration="2000" className='headingAbout mBottom'>About Festival</h3>
                     <p data-aos="fade-up"
                    data-aos-duration="2000" className='about_para_bold'>"THE BLUES LIVE HERE"</p>
                {/* <p data-aos="fade-up"
                    data-aos-duration="2000" className='about_para'>The Mahindra Blues Festival is not just another music festival. </p>
                     <p data-aos="fade-up"
                    data-aos-duration="2000" className='about_para'>It’s a cultural movement. </p> */}
                <p data-aos="fade-up"
                    data-aos-duration="2000" className='about_para'>#TheBluesLiveHere - At the Mahindra Blues Festival, you’re damn right it lives here! 14 years and counting, with a legacy that transcends beyond the Mississippi Delta, finding its little cozy, and humbling home in the hustle of Bombay; the Mahindra Blues lives and breathes as one of Asia’s largest blues festivals.</p>

                <p data-aos="fade-up"
                    data-aos-duration="2000" className='about_para'>Returning to the heart of it all, the iconic and rustic Mehboob Studio, the Mahindra Blues Festival once again promises edgy riffs, soulful blending of emotion and instrument all complementing each other and producing a cacophony of gospel, rock, soul, Americana, and of course - the Blues! 
 </p>
                <p data-aos="fade-up"
                    data-aos-duration="2000" className='about_para'>This is a festival that brings a community together driven by the love for a genre that aches hearts, breaks hearts, and mends it back together all the same; all in one go. A genre associated with grit finds a vibrant, celebrated existence in a city of a million dreams. Get ready to once again, experience International legends, and Indian maestros, witness their electrifying heart and soul pour out on the stages we have all come to call our Bluesy home, where we irrevocably hold on to every note.  </p>
                <p data-aos="fade-up"
                    data-aos-duration="2000" className='about_para'>Yeap, you’re God-damn right, The Blues Live Here and it’s here to stay! 
</p>

                
            </section>
        </div>
    )
}

export default AboutUs